<template>
  <div class="about">
    <!-- <h3>JOYINME PTE. LTD</h3> -->
    <!-- <h3>JOYINME PTE. LTD.</h3> -->
    <h3>IN2FUN PTE. LTD.</h3>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
  .about{
    height: 100%;
    display: flex;
    justify-content:center;
    align-items: center;
    flex-flow: column;
  }
</style>
